import { Onboarding } from "../../../components/Sections/Onboarding";

const Home1 = () => {
  return (
    <div>
      <Onboarding
        linkto={"/signup"}
        heading={"Grow Your Income"}
        body={
          "MecGlobal is a Japan-based holding company primarily engaged in the recycling of resources."
        }
        imgurl={"/img/new/background/mecglobal.jpg"}
        next={"/home2"}
      />
    </div>
  );
};

export default Home1;
